import React, { useEffect, useState, useCallback } from 'react';
import { Row, Col, Card, Statistic, theme, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  UserOutlined,
  MessageOutlined,
  DollarOutlined,
  CommentOutlined,
  FileOutlined
} from '@ant-design/icons';
import { useTheme } from '../Shared/GlobalContext/ThemeContext';
import { useGlobal } from '../Shared/GlobalContext/GlobalContext';
import { getStats } from './HomeServices';
import { useErrorHandler } from '../../Hooks/useErrorHandler';

const Dashboard = () => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  const { token } = theme.useToken();
  const { handleError } = useErrorHandler();
  const { setLoading } = useGlobal();
  const [stats, setStats] = useState(null);

  const fetchStats = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await getStats();
      setStats(data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  }, [setLoading, handleError]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  const kpis = [
    { title: t('number_of_agents'), value: stats?.created_agents, icon: <UserOutlined /> },
    { title: t('number_of_contacts'), value: stats?.created_contacts, icon: <UserOutlined /> },
    { title: t('available_coins'), value: stats?.available_coins, icon: <DollarOutlined /> },
    { title: t('number_of_conversations'), value: stats?.created_conversations, icon: <MessageOutlined /> },
    { title: t('number_of_messages'), value: stats?.created_messages, icon: <CommentOutlined /> },
    { title: t('number_of_knowledge_bases'), value: stats?.created_knowledge_bases, icon: <FileOutlined /> }
  ];

  const cardStyle = {
    backgroundColor: token.colorBgContainer,
    color: token.colorText,
    border: isDarkMode ? `1px solid ${token.colorBorder}` : 'none',
  };

  const kpiTextStyle = {
    color: token.colorText
  };

  const renderCards = () => {
    if (!stats) {
      return Array(6).fill(null).map((_, index) => (
        <Col xs={24} sm={12} md={8} key={index}>
          <Card bordered={false} style={cardStyle} size="small">
            <Skeleton active paragraph={{ rows: 1 }} />
          </Card>
        </Col>
      ));
    }

    return kpis.map((kpi, index) => (
      <Col xs={24} sm={12} md={8} key={index}>
        <Card bordered={false} hoverable style={cardStyle}>
          <Statistic
            title={<span style={kpiTextStyle}>{kpi.title}</span>}
            value={kpi.value || '-'}
            prefix={kpi.icon}
            valueStyle={{ color: '#1890ff' }}
          />
        </Card>
      </Col>
    ));
  };

  return (
    <Row gutter={[16, 16]}>
      {renderCards()}
    </Row>
  );
};

export default Dashboard;